import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import KeycloakService from "@/core/services/KeycloakService";
import MensagemService from "@/core/services/MensagemService";

import { paremetros_por_escola } from "./parametros-por-escola/index";
import { parametros_por_municipio } from "./parametros-por-municipio/index";
import { parametros_de_escolaridade } from "./parametros-de-escolaridade/index";
import { parametros_de_atendimento } from "./parametros-de-atendimento/index";
import { manutencao_de_turma } from "./manutencao-de-turma/index";
import { gerar_arquivo_de_turmas } from "./gerar-arquivo-de-turmas/index";
import { geracao_das_vagas } from "./geracao-das-vagas/index";
import { manutencao_das_vagas } from "./manutencao-das-vagas/index";
import { consulta_de_vagas } from "./consulta-de-vagas/index";
import { geracao_de_arquivo_de_vagas } from "./geracao-de-arquivo-de-vagas/index";
import { geracao_de_arquivo_retrato_da_matricula } from "./geracao-de-arquivo-do-retrato-da-matricula/index";
import { relatorio_de_apoio_gerencial_escola } from "./relatorio-de-apoio-gerencial-escola/index";
import { relatorio_de_apoio_gerencial_da_turma } from "./relatorio-de-apoio-gerencial-da-turma/index";
import { unificacao_aluno } from "./unificacao-de-aluno/index";
import { manutencao_de_aluno } from "./manutencao-de-aluno";
import { reserva_de_vaga } from "./reserva-de-vaga/index";
import { consulta_de_alunos_com_reserva_de_vagas_web } from "./consulta-de-alunos-com-reserva-de-vagas-web";
import { consulta_reserva_de_vaga } from "./consulta-reserva-de-vaga/index";
import { tabelas_auxiliares } from "./tabelas-auxiliares";
import { reordenamento_das_escolas } from "./reordenamento-das-escolas";
import { gerar_previsao_de_rendimento } from "./gerar-previsao-de-rendimento";
import { cargas_escolas } from "./cargas-escolas/index";
import { retrato_de_matricula_inicial } from "./retrato-de-matricula-inicial/index";
import { estimativa_de_matricula } from "./estimativa-de-matricula/index";
import { ajuste_estimativa_de_matricula_reordenamento } from "./ajuste-estimativa-de-matricula-reordenamento/index";
import { confirmar_estimativa_de_matricula } from "./confirmar-estimativa-de-matricula/index";
import { reordenamento } from "./reordenamento/index";
import { transferencia_do_aluno } from "./transferencia-do-aluno/index";
import { enturmar_alunos } from "./enturmar-alunos";
import { diario_de_classe_da_turma } from "./diario-de-classe-da-turma";
import { retrato_de_matricula_diaria } from "./retrato-de-matricula-diaria/index";
import { manutencao_matricula } from "./manutencao-matricula";
import { manutencao_historico } from "./manutencao-historico";
import { tabelas_apoio } from "./tabelas-apoio";
import { relacao_escola_contraturno } from "./relacao-escola-contraturno";
import { useUsuarioStore } from "@/store/usuarioStore";

import { auth } from "./auth/index";

import { dashaboard } from "./dashboard/index";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/layout/Layout.vue"),
    children: [
      dashaboard,
      ...paremetros_por_escola,
      ...parametros_por_municipio,
      ...parametros_de_escolaridade,
      ...parametros_de_atendimento,
      ...manutencao_historico,
      ...manutencao_de_turma,
      ...gerar_arquivo_de_turmas,
      ...geracao_das_vagas,
      ...manutencao_das_vagas,
      ...consulta_de_vagas,
      ...geracao_de_arquivo_de_vagas,
      ...geracao_de_arquivo_retrato_da_matricula,
      ...relatorio_de_apoio_gerencial_escola,
      ...relatorio_de_apoio_gerencial_da_turma,
      ...unificacao_aluno,
      ...manutencao_de_aluno,
      ...reserva_de_vaga,
      ...consulta_de_alunos_com_reserva_de_vagas_web,
      ...consulta_reserva_de_vaga,
      ...reordenamento_das_escolas,
      ...cargas_escolas,
      ...gerar_previsao_de_rendimento,
      ...retrato_de_matricula_inicial,
      ...estimativa_de_matricula,
      ...ajuste_estimativa_de_matricula_reordenamento,
      ...confirmar_estimativa_de_matricula,
      ...reordenamento,
      ...transferencia_do_aluno,
      ...enturmar_alunos,
      ...diario_de_classe_da_turma,
      ...retrato_de_matricula_diaria,
      ...tabelas_auxiliares,
      ...manutencao_matricula,
      ...tabelas_apoio,
      ...relacao_escola_contraturno,
    ],
  },
  ...auth,
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

function validarAutorizacao(to, permissions) {
  if (to.meta.requireAuth === false) {
    return true;
  }

  if (!KeycloakService.getInstance().authenticated) {
    window.location.href = process.env?.VUE_APP_REDIRECT_LOGIN || "";
  }

  if (!to.meta.allowedPermissions) {
    return true;
  }

  if (!Array.isArray(to.meta.allowedPermissions)) {
    return false;
  }

  if (to.meta.allowedPermissions.some((item) => permissions.includes(item))) {
    return true;
  }

  return false;
}

router.beforeEach(async (to, from, next) => {
  //reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  const usuarioStore = useUsuarioStore();
  if (!usuarioStore.dadosCarregados) {
    try {
      await usuarioStore.carregarDadosUsuario();
    } catch (error) {
      console.error("Erro ao carregar dados do usuário:", error);
    }
  }

  const storedMenuData: string = localStorage.getItem("menuData") || "";
  const permissions = Object.values(JSON.parse(storedMenuData)).flat();

  if (validarAutorizacao(to, permissions)) {
    next();
  } else {
    MensagemService.erro({
      texto: "Você não tem permissão para acessar este recurso!",
      confirmButtonText: "OK",
    });
  }

  //Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
